// extracted by mini-css-extract-plugin
module.exports = {"forgotPass":"login_forgotPass__1Dz7e","orContainer":"login_orContainer__3rZRl","errorBlock":"login_errorBlock___ScXe","forgotSuccess":"login_forgotSuccess__3QK5i"};